import React, { useEffect, useState } from "react";
import ErrorPage from "../../../../assets/Graphics/Error page graphic.svg";
import DeclinedRed from "../../../../assets/ErrorIcons/error_with_white_outlined_circle.svg";
import WhitedashBoard from "../../../../assets/GeneralIcons/dashboard.svg";
import "./index.css";
import { Tooltip, tooltipClasses } from "@mui/material";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const BeneficiaryMultiApprovalErrorPage = () => {
  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state.beneTxnViewAccData);

  const [ErrorPageData, setErrorPageData] = useState([]);
  const [activeTab, setActiveTab] = useState(true);
  const [isMobileResponsive, setIsMobileResponsive] = useState(
    window.innerWidth <= 800
  );

  const findCommonNames = (arr1, arr2) => {
    let type = arr2.some((item) => typeof item === "string");
    if (type) {
      return arr2;
    } else {
      const arr2Map = new Map(arr2?.map((item) => [item?.id, item?.errors]));

      return arr1
        .filter((item) => arr2Map?.has(item.txn_id))
        .map((item) => ({
          ...item,
          errors: arr2Map?.get(item.txn_id),
        }));
    }
  };
  const filterErrorTxn = findCommonNames(
    ErrorPageData,
    JSON.parse(sessionStorage.getItem("selectedDataError"))
  );
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData")
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileResponsive(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const renderAccount = (account, index, isErrorPage) =>
    isMobileResponsive ? (
      <>
        <div className="flex justify-between pb-2">
          <div className="flex justify-center items-center gap-[10px] pt-3">
            <img className="w-[20px] h-[20px]" src={DeclinedRed} alt="" />
            <div>
              <Tooltip
                componentsProps={{
                  popper: {
                    sx: {
                      [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: (theme) => theme.palette.common.black,
                      },
                    },
                  },
                }}
                title={account?.beneficiary_account_name}
              >
                <p className="whitespace-nowrap overflow-ellipsis overflow-hidden first-line:capitalize lowercase w-[167px] h-[22px] text-left font-sans font-medium text-[14px]  text-[#1D1D1D]">
                  {account.beneficiary_account_name}
                </p>
              </Tooltip>
              <span className="flex  w-[110px]  text-left font-sans text-[11px]  text-[#707070] opacity-100">
                Beneficiary name
              </span>
            </div>
          </div>
          <div className="pt-3">
            <p className="min-w-0 whitespace-nowrap h-[22px]  font-semibold text-[14px]  text-[#FF5860] opacity-100">
              ₹ {<FormatAmount price={account?.amount} />}
            </p>
            <span className="flex justify-end  items-end font-sans text-[11px]  text-[#707070] opacity-100">
              Amount
            </span>
          </div>
        </div>
        {isErrorPage
          ? index < ErrorPageData.length - 1 && (
              <div
                style={{
                  border: "1px solid #DADADA",
                  height: "0px",
                  width: "411px",
                  opacity: "100",
                }}
              ></div>
            )
          : index < ErrorPageData.length - 1 && (
              <div
                style={{
                  border: "1px solid #DADADA",
                  height: "0px",
                  width: "411px",
                  opacity: "100",
                }}
              ></div>
            )}
      </>
    ) : (
      <>
        <div className="flex justify-between pb-[10px] pt-[10px]">
          <div className="flex justify-center items-center gap-[10px]">
            <img className="w-[30px] h-[30px]" src={DeclinedRed} alt="" />
            <div>
              <Tooltip
                componentsProps={{
                  popper: {
                    sx: {
                      [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: (theme) => theme.palette.common.black,
                      },
                    },
                  },
                }}
                title={account?.beneficiary_account_name}
              >
                <p className="whitespace-nowrap overflow-ellipsis overflow-hidden first-line:capitalize lowercase w-[167px] h-[22px] text-left font-sans font-semibold text-[16px] leading-[22px] tracking-normal text-black">
                  {account.beneficiary_account_name}
                </p>
              </Tooltip>
              <span className="flex items-start w-[110px] h-[17px] text-left font-sans text-[12px] leading-[17px] tracking-normal text-[#828282] opacity-100">
                Beneficiary name
              </span>
            </div>
          </div>
          <div>
            <p className="min-w-0 whitespace-nowrap h-[22px] text-right font-sans font-semibold text-[16px] leading-[22px] tracking-normal text-[#FF5860] opacity-100">
              ₹ {<FormatAmount price={account?.amount} />}
            </p>
            <span className="flex justify-end items-end font-sans text-[12px] leading-[17px] text-[#828282] opacity-100">
              Amount
            </span>
          </div>
        </div>
        {isErrorPage
          ? index < ErrorPageData.length - 1 && (
              <div
                style={{
                  marginTop: "10px",
                  border: "1px solid #DADADA",
                  height: "0px",
                  width: "auto",
                  opacity: "100",
                }}
              ></div>
            )
          : index < ErrorPageData.length - 1 && (
              <div
                style={{
                  border: "1px solid #DADADA",
                  height: "0px",
                  width: "auto",
                  opacity: "100",
                }}
              ></div>
            )}
      </>
    );
  return (
    <>
      {isMobileResponsive ? (
        <div
          className=" bg-[#754545]"
          style={{
            height: "100vh",
          }}
        >
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[170px] w-[250px]"
              src={ErrorPage}
              alt="ErrorPage"
            />
            <h2 className="  text-center text-[22px] font-semibold  text-[#F9F9F9]">
              Oops,
            </h2>
            <p className="text-center  pt-[1px]  text-[15px] font-semibold  text-[#F9F9F9] opacity-100">
              {BeneTxnMultiApprovalError
                ? "Transaction approval failed"
                : BeneTxnMultiDeniedApprovalError
                ? "Transaction rejection failed"
                : ""}
            </p>
            <span className="w-[298px] text-center text-[12px] pt-[4px] pb-[20px] font-normal  text-[#F9F9F9]">
              An error occurred with the following transactions, causing the{" "}
              {BeneTxnMultiApprovalError ? "approval" : "rejection"} of all the
              transactions to fail.
            </span>
          </div>
          <div
            className=""
            style={{
              height: "calc(100vh - 300px)",
            }}
          >
            <div
              className=" flex justify-between h-[46px]"
              style={{
                background: "#985555",
              }}
            >
              <div
                className="w-[50%] h-full opacity-100 flex justify-center items-center cursor-pointer"
                style={{
                  backgroundColor: activeTab === true ? "#985555" : "#864C4C",
                }}
                onClick={() => {
                  setActiveTab(true);
                }}
              >
                <h4 className="w-[72px] h-[16px] text-left text-[12px] font-semibold  text-[#F9F9F9]">
                  Error details
                </h4>
              </div>
              <div
                className="w-[50%] h-full   opacity-100 flex justify-center items-center cursor-pointer"
                style={{
                  backgroundColor: activeTab === false ? "#985555" : "#864c4c",
                }}
                onClick={() => {
                  setActiveTab(false);
                }}
              >
                <h4 className="w-[111px] h-[16px] text-left text-[12px] font-semibold  text-[#F9F9F9]">
                  Transaction details
                </h4>
              </div>
            </div>
            <div
              className=" bg-[#F9F9F9]"
              style={{
                height: "calc(100vh - 414px)",
              }}
            >
              {activeTab === false ? (
                <div
                  className=" flex  justify-center pb-[20px]   pl-[10px] pr-[10px] "
                  style={{
                    overflowY: ErrorPageData.length > 4 ? "scroll" : "hidden",
                    overflowX: "hidden",
                    height: "calc(100vh - 430px)",
                    paddingBottom: "20px",
                  }}
                >
                  <div className="w-full">
                    {Array.isArray(filterErrorTxn) &&
                    filterErrorTxn.length > 0 ? (
                      filterErrorTxn.some(
                        (error) =>
                          typeof error === "string" &&
                          error.includes(
                            "No transactions found for transaction ids"
                          )
                      ) ? (
                        ErrorPageData?.map((account, i) =>
                          renderAccount(account, i, true)
                        )
                      ) : (
                        filterErrorTxn.map((account, i) => {
                          return renderAccount(account, i);
                        })
                      )
                    ) : (
                      <p>No transactions available.</p>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className="h-full pt-[15px] flex flex-col"
                  style={{
                    overflow: "hidden",
                    width: "100%",
                    overflowY: "auto",
                    paddingTop: "15px",
                    paddingBottom: "15px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {filterErrorTxn?.map((val, i) => {
                    return (
                      <div key={i}>
                        {val?.errors ? (
                          <>
                            {typeof val.errors[0]?.reason === "string" ? (
                              <div className="inner_error_msg_title">
                                {i === 0 ? (
                                  <>
                                    <h4>No transactions found.</h4>
                                    <p>{val.errors[0].reason}</p>
                                  </>
                                ) : null}
                              </div>
                            ) : (
                              <div className="w-full">
                                <div className="w-full h-[47px] bg-[#DADADA] pt-1 pl-[15px]">
                                  <h4 className="lowercase first-line:capitalize w-[230px]  overflow-hidden overflow-ellipsis whitespace-nowrap font-medium text-[14px]  text-[#1D1D1D]">
                                    {val.beneficiary_account_name}
                                  </h4>

                                  <h6 className="w-[185px] h-[16px] text-[12px] font-normal text-[#707070]">
                                    Beneficiary name
                                  </h6>
                                </div>

                                {val.errors.map((error, index) => (
                                  <div
                                    className=" pl-[15px] pt-3 text-[14px] font-normal text-[#1D1D1D] pb-[15px]"
                                    key={index}
                                    style={{
                                      borderBottom:
                                        val.errors.length - 1 === index
                                          ? ""
                                          : "1px solid #dadada",
                                    }}
                                  >
                                    <h4 className="">
                                      {error?.reason || error}
                                    </h4>
                                    <p className="w-[330px] h-[16px] text-[12px] font-normal text-[#707070] pt-[3px] ">
                                      Error message
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="pl-[15px] pt-1 text-[14px] font-normal text-[#1D1D1D] pb-[15px]">
                            <h4>No transactions found.</h4>
                            <p className="w-[330px] h-[16px] text-[12px] font-normal text-[#707070] pt-[3px]">
                              Error message
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {/* top-[-24px] */}
            <div className="  h-[105px] rounded-tl-[20px] bg-[#985555] fixed  bottom-0 w-[100%]  rounded-tr-[20px]">
              <Link to={"/transaction/beneficiary_transaction/dashboard"}>
                <div className="flex flex-col gap-1 justify-center items-center h-full">
                  <img
                    className="w-[33px] h-[33px]"
                    src={WhitedashBoard}
                    alt=""
                  />
                  <p className="w-[63px] h-[32px]  text-center text-[12px] font-semibold  text-[#F9F9F9]">
                    Go to dashboard
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="min-h-screen bg-[#754545]">
          <div className="flex justify-center">
            <div className="flex flex-row max-w-screen-Qlg justify-center">
              <div className="flex-1 mt-[66px] pt-[90px]">
                <div className="flex min-w-screen mx-5 justify-center items-center bg-[#754545]">
                  <div className="p-2 flex flex-col items-center justify-center">
                    <img
                      className=""
                      src={ErrorPage}
                      width={"90%"}
                      height={"100%"}
                      alt=""
                      srcSet=""
                    />
                    <div className="pt-[1px] flex flex-col justify-center items-center">
                      <p className="text-left font-sans font-bold text-[40px] tracking-normal text-[#F9F9F9] opacity-100">
                        Oops!
                      </p>
                      <span className="text-left font-sans font-semibold text-2xl tracking-normal text-[#F9F9F9] opacity-100">
                        {BeneTxnMultiApprovalError
                          ? "Transaction approval failed"
                          : BeneTxnMultiDeniedApprovalError
                          ? "Transaction rejection failed"
                          : ""}
                      </span>
                      <span className="text-center mt-2.5 font-sans text-base tracking-normal text-white opacity-100">
                        An error occurred with the following transactions,
                        <br />
                        causing the{" "}
                        {BeneTxnMultiApprovalError
                          ? "approval"
                          : "rejection"}{" "}
                        of all the transactions to fail.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 mt-[66px] py-[35px]">
                <div className="flex flex-col h-[554px] w-[472px] mx-5 bg-[#FFFFFF] rounded-[25px] items-center justify-between">
                  <div className="w-[472px] flex justify-center items-center bg-[#985555] rounded-tl-[20px] rounded-tr-[20px]">
                    <div
                      className="txn_error_swap_tab_left"
                      style={{
                        backgroundColor:
                          activeTab === true ? "#985555" : "#864c4c",
                      }}
                      onClick={() => {
                        setActiveTab(true);
                      }}
                    >
                      <h4>Error details</h4>
                    </div>
                    <div
                      className="txn_error_swap_tab_right"
                      style={{
                        backgroundColor:
                          activeTab === false ? "#985555" : "#864c4c",
                      }}
                      onClick={() => {
                        setActiveTab(false);
                      }}
                    >
                      <h4>Transaction details</h4>
                    </div>
                  </div>
                  {activeTab === false ? (
                    <div
                      className="h-[335px] w-[472px] flex justify-center"
                      style={{
                        overflowY:
                          ErrorPageData.length > 5 ? "scroll" : "hidden",
                        marginTop: "6px",
                        paddingBottom: "20px",
                      }}
                    >
                      <div
                        className="w-full mt-[10px] px-5"
                        style={{ height: "fit-content" }}
                      >
                        {Array.isArray(filterErrorTxn) &&
                        filterErrorTxn.length > 0 ? (
                          filterErrorTxn.some(
                            (error) =>
                              typeof error === "string" &&
                              error.includes(
                                "No transactions found for transaction ids"
                              )
                          ) ? (
                            ErrorPageData?.map((account, i) =>
                              renderAccount(account, i, true)
                            )
                          ) : (
                            filterErrorTxn.map((account, i) => {
                              return renderAccount(account, i);
                            })
                          )
                        ) : (
                          <p>No transactions available.</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div
                      className="h-[335px] w-[472px] "
                      style={{
                        overflowY: "auto",
                        paddingTop: "10px",
                        paddingBottom: "20px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {filterErrorTxn?.map((val, i) => {
                        return (
                          <div key={i}>
                            {val?.errors ? (
                              <>
                                {typeof val.errors[0]?.reason === "string" ? (
                                  <div className="inner_error_msg_title">
                                    {i === 0 ? (
                                      <>
                                        <h4>No transactions found.</h4>
                                        <p>{val.errors[0].reason}</p>
                                      </>
                                    ) : null}
                                  </div>
                                ) : (
                                  <div className="inner_error_msg">
                                    <div className="inner_error_msg_name">
                                      <h4 className="lowercase first-line:capitalize">
                                        {val.beneficiary_account_name}
                                      </h4>
                                      <h6>Beneficiary name</h6>
                                    </div>

                                    {val.errors.map((error, index) => (
                                      <div
                                        className="inner_error_msg_title"
                                        key={index}
                                        style={{
                                          borderBottom:
                                            val.errors.length - 1 === index
                                              ? ""
                                              : "1px solid #dadada",
                                        }}
                                      >
                                        <h4>{error?.reason || error}</h4>
                                        <p>Error message</p>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="inner_error_msg_title">
                                <h4>No transactions found.</h4>
                                <p>Error message</p>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div className="flex justify-center items-center h-[136px] w-[472px] bg-[#985555] rounded-[20px]">
                    <Link to={"/transaction/beneficiary_transaction/dashboard"}>
                      <div className="w-[62px] flex justify-center items-center flex-col gap-[4px]  h-[76px]">
                        <img
                          className="w-[40px] h-[40px]"
                          src={WhitedashBoard}
                          alt=""
                        />
                        <p className="w-[62px] h-[32px] text-center font-semibold text-[12px] leading-[15px] tracking-[0px] text-[#FFFFFF] opacity-100">
                          Go to dashboard
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BeneficiaryMultiApprovalErrorPage;
